// extracted by mini-css-extract-plugin
export default {"container":"ConflictWarning-module__container___Wpe_V","warning":"ConflictWarning-module__warning___xHahb","warningToolTip":"ConflictWarning-module__warningToolTip___qGgsT"};